/**
 * MobileViewContext.js
 * 모바일 뷰 전환 관리
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { detectMobileDevice } from '../utils/deviceDetection';

const MobileViewContext = createContext();

export const useMobileView = () => {
  const context = useContext(MobileViewContext);
  if (!context) {
    throw new Error('useMobileView must be used within a MobileViewProvider');
  }
  return context;
};

export const MobileViewProvider = ({ children }) => {
  // 모바일 뷰 감지: localStorage 설정값 또는 실제 모바일 디바이스 감지
  const [isMobileView, setIsMobileView] = useState(() => {
    // localStorage에 명시적으로 설정된 값이 있으면 우선 사용
    const saved = localStorage.getItem('mobileView');
    if (saved === 'true' || saved === 'false') {
      return saved === 'true';
    }
    
    // localStorage에 값이 없으면 실제 디바이스/화면 크기로 감지
    return detectMobileDevice();
  });

  // 모바일 뷰 전환 함수
  const toggleMobileView = () => {
    const newValue = !isMobileView;
    setIsMobileView(newValue);
    localStorage.setItem('mobileView', newValue.toString());
    
    // body에 클래스 추가/제거
    if (newValue) {
      document.body.classList.add('mobile-view');
    } else {
      document.body.classList.remove('mobile-view');
    }
  };

  // isMobileView 변경 시 body 클래스 업데이트
  useEffect(() => {
    if (isMobileView) {
      document.body.classList.add('mobile-view');
    } else {
      document.body.classList.remove('mobile-view');
    }
    
    return () => {
      document.body.classList.remove('mobile-view');
    };
  }, [isMobileView]); // isMobileView가 변경될 때마다 실행

  const value = {
    isMobileView,
    toggleMobileView,
    setIsMobileView,
  };

  return (
    <MobileViewContext.Provider value={value}>
      {children}
    </MobileViewContext.Provider>
  );
};

export default MobileViewContext;

